import makeStyles from '@mui/styles/makeStyles';
import { Box, Typography } from '@mui/material';
import React from 'react';

type DealContextSectionProps = {
    isPlainText: boolean;
    text?: string;
    context?: string;
    commentary?: string;
    decision?: string;
};

const useStyles = makeStyles(() => ({
    fieldLabel: {
        fontSize: 12,
        color: '#6c757d',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        marginBottom: 8,
    },
}));

const DealContextSection: React.FC<DealContextSectionProps> = ({
    isPlainText, text, context, commentary, decision,
}) => {
    const classes = useStyles();
    return (
        <Box sx={{ p: 2, border: '1px solid #e9ecef', borderRadius: 1, backgroundColor: '#fafbfc' }}>
            {isPlainText ? (
                <Typography sx={{ fontSize: 14, color: '#2c3e50', lineHeight: 1.6 }}>
                    {text}
                </Typography>
            ) : (
                <>
                    {context && (
                        <Box sx={{ mb: 2 }}>
                            <Typography className={classes.fieldLabel}>Deal Overview</Typography>
                            <Typography sx={{ fontSize: 14, color: '#2c3e50', lineHeight: 1.6 }}>
                                {context}
                            </Typography>
                        </Box>
                    )}
                    {commentary && (
                        <Box sx={{ backgroundColor: '#fffbeb', border: '1px solid #fde68a', borderRadius: 1, p: 2, mb: 2 }}>
                            <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#92400e', textTransform: 'uppercase', letterSpacing: '0.05em', mb: 1 }}>
                                Commentary
                            </Typography>
                            <Typography sx={{ fontSize: 14, color: '#2c3e50', lineHeight: 1.6 }}>
                                {commentary}
                            </Typography>
                        </Box>
                    )}
                    {decision !== undefined && (
                        <Box sx={{ display: 'flex', alignItems: 'center', pt: 1.5, borderTop: '1px solid #e9ecef' }}>
                            <Typography component="span" sx={{ fontSize: 11, fontWeight: 600, color: '#6b7280', textTransform: 'uppercase' }}>
                                Decision:
                            </Typography>
                            <Typography component="span" sx={{ fontSize: 14, fontWeight: 700, color: '#111827', ml: 0.5 }}>
                                {decision || 'none'}
                            </Typography>
                        </Box>
                    )}
                </>
            )}
        </Box>
    );
};

export default DealContextSection;
